import React from "react";
import vi from "../../../assets/common/vi.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

// check input validation
export const CFV = (key, msg, errors) => (
  <div style={{ color: "red", marginBottom: "0px" }}>
    {errors && errors[key] ? (
      msg
    ) : Object.keys(errors).length > 0 ? (
      <img src={vi} alt={"vi"} style={{ width: "20px", marginRight: "0px" }} />
    ) : (
      <div style={{ height: "20px" }} />
    )}
  </div>
);

export const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
    toast.info("הועתק בהצלחה!");
  } catch (err) {
    toast.error("העתקה נכשלה, יש לפנות למנהל המערכת");
  }
};

export const days = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return parseInt(TotalDays);
};

export const parseIsoDate = (date) =>
  date.toISOString().replace(/T.*/, "").split("-").reverse().join("/");

export const dateFormat = (date) =>
  date.replace(/T.*/, "").split("-").reverse().join("/");

export const handleClickScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

export const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + ".xlsx");
};

export const normalizeGuestNameForCompare = (name) => {
  if (name == null) return "";
  return String(name).replace(/\s+/g, " ").trim();
};

export const normalizeGuestPhoneForCompare = (phone) => {
  if (phone == null || phone === "") return "";
  let digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("972") && digits.length >= 11) {
    digits = `0${digits.slice(3)}`;
  } else if (digits.length === 9 && digits[0] !== "0") {
    digits = `0${digits}`;
  }
  return digits;
};

const parseExcelAcceptCell = (v) => {
  if (v === undefined || v === null || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

const systemAcceptNumber = (g) => {
  if (g == null) return null;
  if (g.accept === null || g.accept === undefined || g.accept === "")
    return null;
  const n = Number(g.accept);
  return Number.isNaN(n) ? null : n;
};

const buildDuplicateNameSet = (names) => {
  const counts = new Map();
  for (const name of names) {
    if (!name) continue;
    counts.set(name, (counts.get(name) || 0) + 1);
  }
  return new Set(
    [...counts.entries()].filter(([, count]) => count > 1).map(([name]) => name),
  );
};

const buildExcelExportIndex = (excelRows, ambiguousNames) => {
  const byName = new Map();
  const byPhone = new Map();
  const allNames = new Set();
  const allPhones = new Set();

  for (const row of excelRows) {
    if (ambiguousNames.has(row.name)) {
      if (row.phone) byPhone.set(row.phone, row);
    } else {
      byName.set(row.name, row);
    }
    allNames.add(row.name);
    if (row.phone) allPhones.add(row.phone);
  }

  return { byName, byPhone, allNames, allPhones };
};

const findExcelRowForGuest = (guest, ambiguousNames, excelIndex) => {
  const name = normalizeGuestNameForCompare(guest?.name);
  if (!name) return null;

  const phone = normalizeGuestPhoneForCompare(guest?.phone);
  if (ambiguousNames.has(name)) {
    if (!phone) return null;
    return excelIndex.byPhone.get(phone) || null;
  }
  return excelIndex.byName.get(name) || null;
};

const isGuestInExcel = (guest, ambiguousNames, excelIndex) =>
  findExcelRowForGuest(guest, ambiguousNames, excelIndex) != null;

const compareExportRowsToGuests = (excelRows, guests) => {
  const guestList =
    guests && !Array.isArray(guests) ? Object.values(guests) : guests || [];
  const ambiguousNames = new Set([
    ...buildDuplicateNameSet(excelRows.map((row) => row.name)),
    ...buildDuplicateNameSet(
      guestList.map((g) => normalizeGuestNameForCompare(g?.name)),
    ),
  ]);
  const excelIndex = buildExcelExportIndex(excelRows, ambiguousNames);
  const lines = [];

  for (const g of guestList) {
    if (!g) continue;
    const ex = findExcelRowForGuest(g, ambiguousNames, excelIndex);
    if (!ex) continue;
    const sysNorm = systemAcceptNumber(g);
    if (ex.excelAccept !== sysNorm) {
      const exStr = ex.excelAccept === null ? "ריק" : String(ex.excelAccept);
      const syStr = sysNorm === null ? "ריק" : String(sysNorm);
      const name = normalizeGuestNameForCompare(g.name);
      const phoneSuffix =
        ambiguousNames.has(name) && g.phone ? ` (${g.phone})` : "";
      lines.push(`${g.name}${phoneSuffix} באקסל ${exStr} אבל במערכת ${syStr}`);
    }
  }

  const newSinceExport = [];
  for (const g of guestList) {
    if (!g) continue;
    const name = normalizeGuestNameForCompare(g.name);
    if (!name) continue;
    if (!(g.accept != null && Number(g.accept) > 0)) continue;
    if (!isGuestInExcel(g, ambiguousNames, excelIndex)) newSinceExport.push(g);
  }

  return { lines, newSinceExport };
};

/** קריאת קובץ ייצוא תבנית: שורות מ־A3, עמודה A שם, B אישור, E נייד */
export const parseWeddingInvitationsExportWorkbook = (wb) => {
  const sheetName = wb.SheetNames.includes("הזמנות")
    ? "הזמנות"
    : wb.SheetNames[0];
  const ws = wb.Sheets[sheetName];
  if (!ws) return [];
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
  const excelRows = [];
  for (let i = 2; i < rows.length; i++) {
    const row = rows[i] || [];
    const name = normalizeGuestNameForCompare(row[0]);
    if (!name) continue;
    excelRows.push({
      name,
      phone: normalizeGuestPhoneForCompare(row[4]),
      excelAccept: parseExcelAcceptCell(row[1]),
      displayName: String(row[0]).trim(),
    });
  }
  return excelRows;
};

/**
 * השוואת קובץ ייצוא קודם (עמודה B) ל־guest.accept הנוכחי.
 * שם ייחודי — לפי שם; שם כפול (בקובץ או במערכת) — לפי טלפון.
 */
export const compareWeddingExportToGuests = (wb, guests) => {
  const excelRows = parseWeddingInvitationsExportWorkbook(wb);
  return compareExportRowsToGuests(excelRows, guests);
};

export const compareWeddingExportFromArrayBuffer = (buffer, guests) => {
  const wb = XLSX.read(buffer, { type: "array" });
  return compareWeddingExportToGuests(wb, guests);
};

/** ייצוא תבנית הזמנות לרשימת אורחים (למשל רק „חדשים מאז”) */
export const exportWeddingInvitationsTemplateForGuestList = async (
  confirmedGuests,
  fileName = "הזמנות_תבנית.xlsx",
) => {
  try {
    if (!confirmedGuests || confirmedGuests.length === 0) {
      toast.warning("אין אורחים לייצוא");
      return;
    }
    const base = process.env.PUBLIC_URL || "";
    const res = await fetch(`${base}/wedding_invitations_template_he-IL.xls`);
    if (!res.ok) {
      toast.error("לא ניתן לטעון את תבנית האקסל");
      return;
    }
    const buf = await res.arrayBuffer();
    const wb = XLSX.read(buf, { type: "array" });
    const sheetName = wb.SheetNames[0];
    const ws = wb.Sheets[sheetName];
    const rows = confirmedGuests.map((g) => [
      g.name ?? "",
      g.accept != null && g.accept !== "" ? Number(g.accept) : "",
      "כלה",
      g.closeness ?? "",
      g.phone ?? "",
    ]);
    XLSX.utils.sheet_add_aoa(ws, rows, { origin: "A3" });
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(
      data,
      fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`,
    );
  } catch (e) {
    console.error(e);
    toast.error("שגיאה בייצוא הקובץ");
  }
};

/** ייצוא לתבנית הזמנות חיצונית: כל האורחים עם accept חיובי; עמודות A–E מתוך התבנית ב-public */
export const exportWeddingInvitationsTemplateHeIL = async (guests) => {
  const guestList =
    guests && !Array.isArray(guests) ? Object.values(guests) : guests || [];
  const confirmed = guestList.filter(
    (g) => g != null && g.accept != null && Number(g.accept) > 0,
  );
  if (confirmed.length === 0) {
    toast.warning("אין אורחים שאישרו הגעה");
    return;
  }
  await exportWeddingInvitationsTemplateForGuestList(
    confirmed,
    "הזמנות_תבנית.xlsx",
  );
};

const shilaInvitationRow = (g) => [
  g.name ?? "",
  g.accept != null && g.accept !== "" ? Number(g.accept) : "",
  g.closeness ?? "",
  g.phone ?? "",
];

/** קריאת קובץ ייצוא שילה: שורת כותרת ב־A1, נתונים מ־A2, עמודה A שם, B אישור, D נייד */
export const parseShilaInvitationsExportWorkbook = (wb) => {
  const sheetName = wb.SheetNames.includes("הזמנות")
    ? "הזמנות"
    : wb.SheetNames[0];
  const ws = wb.Sheets[sheetName];
  if (!ws) return [];
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
  const excelRows = [];
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i] || [];
    const name = normalizeGuestNameForCompare(row[0]);
    if (!name) continue;
    excelRows.push({
      name,
      phone: normalizeGuestPhoneForCompare(row[3]),
      excelAccept: parseExcelAcceptCell(row[1]),
      displayName: String(row[0]).trim(),
    });
  }
  return excelRows;
};

export const compareShilaExportToGuests = (wb, guests) => {
  const excelRows = parseShilaInvitationsExportWorkbook(wb);
  return compareExportRowsToGuests(excelRows, guests);
};

export const compareShilaExportFromArrayBuffer = (buffer, guests) => {
  const wb = XLSX.read(buffer, { type: "array" });
  return compareShilaExportToGuests(wb, guests);
};

/** ייצוא תבנית שילה: 4 עמודות, שורת כותרת ב־A1 ונתונים מ־A2 */
export const exportShilaInvitationsTemplateForGuestList = async (
  confirmedGuests,
  fileName = "הזמנות_שילה.xlsx",
) => {
  try {
    if (!confirmedGuests || confirmedGuests.length === 0) {
      toast.warning("אין אורחים לייצוא");
      return;
    }
    const rows = [
      ["שם מלא", "אישרו", "קטגוריה", "נייד"],
      ...confirmedGuests.map(shilaInvitationRow),
    ];
    const ws = XLSX.utils.aoa_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "הזמנות");
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(
      data,
      fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`,
    );
  } catch (e) {
    console.error(e);
    toast.error("שגיאה בייצוא הקובץ");
  }
};

export const exportShilaInvitationsTemplateHeIL = async (guests) => {
  const guestList =
    guests && !Array.isArray(guests) ? Object.values(guests) : guests || [];
  const confirmed = guestList.filter(
    (g) => g != null && g.accept != null && Number(g.accept) > 0,
  );
  if (confirmed.length === 0) {
    toast.warning("אין אורחים שאישרו הגעה");
    return;
  }
  await exportShilaInvitationsTemplateForGuestList(
    confirmed,
    "הזמנות_שילה.xlsx",
  );
};

export const getImageUrl = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callUp/";

export const getImageUrl2 = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callup/";

export const msg4 = `לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`;
export const msg4B = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי במידה וזה מוסכם מבחינתך אין צורך להתייחס להודעה זו\n\nאם תרצו לשלם עכשיו הסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const msg4nC = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\nנראה כי לא עשיתם מתנות באשראי וממש חבל על הכסף שתפסידו, אם תרצו שנסביר לכם למה תאמרו ואם בכל זאת אתם לא רוצים אז אנא להסדיר תשלום דרך המערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות. 🙏`;
export const msg4nBS = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי אך נראה כי לא עשיתם וממש חבל על הכסף שתפסידו, הסברנו את חשיבות השירות בתחילת התהליך אבל אולי עכשיו לאור התוצאות תרצו שכן לקחת את השירות בסופו של דבר, וגם לא אם לא אז בבקשה נא להסדיר את התשלום\n\nהסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const aviadPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לאביעד במספר 0503064555 ולהסדיר תשלום עבור השירות 🙏`;
export const liorWDPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לליאור במספר 0523665635 ולהסדיר תשלום עבור השירות 🙏`;
export const yosefPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליוסף במספר 0504077789 ולהסדיר תשלום עבור השירות 🙏`;
export const TipTopPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0527007397 ולהסדיר תשלום עבור השירות 🙏`;
export const TomerPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0506654051 ולהסדיר תשלום עבור השירות 🙏`;
export const PolPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לפול במספר 0502692682 ולהסדיר תשלום עבור השירות 🙏`;
export const RazPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לרז במספר 0585958777 ולהסדיר תשלום עבור השירות 🙏`;
export const igalPmPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליגאל במספר 0505533440 ולהסדיר תשלום עבור השירות 🙏`;

export const links = {
  BeSimple: "https://callup.ltd/v/besimple/index.html",
  DIY: "https://callup.ltd/v/diy/index.html",
  TipTop: "https://callup.ltd/v/tiptop/index.html",
  "מארגנת החתונות": "https://callup.ltd/v/wd/index.html",
  "משחק הכיסאות": "https://callup.ltd/v/chairsgame/index.html",
  TomerIsakov: "https://callup.ltd/v/tomer/index.html",
  "דובי הפקות": "https://callup.ltd/v/dubi/index.html",
};
